export const INITIAL_STATE = {
    user: null,
    institution: null,
    room: null,
    rooms: null,
    locationDetails: null,
    purchases: [],
    plans: [],
    states: [],
    languages: [],
    personalData: null,
    locationsLicensed: [],
    afterLoginPath: null,
    userManageableFeatures: {
        CHECK_IN_PHOTO_CAPTURE: true,
    },
};
